export const CONTEXT_LIMITS = {
    MAX_TEXT_CHARS: 1200,
};

export const PageTypes = {
    COURSE_LIST: 'course_list',
    ASSIGNMENT_LIST: 'assignment_list',
    ASSIGNMENT_CREATE: 'assignment_create',
    ASSIGNMENT_OVERVIEW: 'assignment_overview',
    ASSIGNMENT_EDIT: 'assignment_edit',
    GRADING: 'grading',
    ASSIGNMENT_PREVIEW: 'assignment_preview',
    SUBMISSION_LIST: 'submission_list',
    SUBMISSION_DETAIL: 'submission_detail',
    PEOPLE_LIST: 'people_list',
    RUBRIC_LIST: 'rubric_list',
    RUBRIC_CREATE: 'rubric_create',
    RUBRIC_OVERVIEW: 'rubric_overview',
    RUBRIC_EDIT: 'rubric_edit',
    UNKNOWN: 'unknown',
};

export const PageViews = {
    CURRENT_COURSES: 'current_courses',
    ARCHIVED_COURSES: 'archived_courses',
    SUBMISSIONS: 'submissions',
    GRADING_INSIGHTS: 'grading_insights',
};

export const RowTypes = {
    COURSES: 'courses',
    ASSIGNMENTS: 'assignments',
    SUBMISSIONS: 'submissions',
    GRADES: 'grades',
    PEOPLE: 'people',
    RUBRICS: 'rubrics',
};

export const ScopeTypes = {
    USER: 'user',
    COURSE: 'course',
    ASSIGNMENT: 'assignment',
};

export const RouteResources = {
    ASSIGNMENTS: 'assignments',
    PEOPLE: 'people',
    RUBRICS: 'rubrics',
};

export const AssignmentSections = {
    NEW: 'new',
    EDIT: 'edit',
    GRADING: 'grading',
    PREVIEW: 'preview',
    SUBMISSIONS: 'submissions',
};

export const RubricSections = {
    GET_STARTED: 'get-started',
    NEW: 'new',
    EDIT: 'edit',
};
